import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { priceFormatter } from 'ReactApp/Services/Formatters/PriceFormatter';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import IconV1 from '../IconV1/IconV1';

type DeliveryInfoOldProjectV1Props = {
    deliveryInfo: DomainNs.DeliveryInfoOldProjectInterface,
    card: DomainNs.ProductCardV6Interface,
}

const DeliveryInfoOldProjectV1 = (props: DeliveryInfoOldProjectV1Props) => {

    const prepareCost = (cost: number|string|null): string => {
        if (typeof cost === 'number') {
            return priceFormatter.format(cost) + ' руб.';
        } else if (typeof cost === 'string') {
            return cost + ' руб.';
        } else {
            return '';
        }
    }

    const renderDate = (): JSX.Element => {
        return (
            <div className="delivery-info-v1__date">
                {
                    props.deliveryInfo
                    && props.deliveryInfo.date
                    && props.deliveryInfo.date !== null
                    && (
                        <>
                            <span className="delivery-info-v1__label">
                                Ориентировочная дата доставки:&nbsp;
                            </span>
                            <span className="delivery-info-v1__value">
                                {props.deliveryInfo.date as string}
                            </span>
                        </>
                    )
                }
            </div>
        );
    }

    const renderCost = (): JSX.Element => {

        let cost = (props.deliveryInfo.cost as number);

        // временно вводится проверка на поле freeCost
        // цена для проверки берется общая от всего заказа
        if (typeof props.deliveryInfo.freeCost === 'string') {
            let sign = props.deliveryInfo.freeCost.substring(0, 1);
            let checkCost = props.deliveryInfo.freeCost.substring(1);
            if (
                sign === '>' 
                    && 
                (showableCartInstance.totalBaseSum as number) 
                    > 
                parseInt(checkCost)
            ) {
                cost = 0;
            } else if (
                sign === '<'
                    &&
                showableCartInstance.totalBaseSum !== null
                    &&
                showableCartInstance.totalBaseSum 
                    < 
                parseInt(checkCost)
            ) {
                cost = 0;
            }
        }

        return (
            <div className="delivery-info-v1__cost">
                <span className="delivery-info-v1__label">
                    Доставка:&nbsp;
                </span>
                {
                    props.deliveryInfo
                    && typeof props.deliveryInfo.cost !== 'undefined' 
                    && props.deliveryInfo.cost !== null
                    && (
                        <>
                            <span className="delivery-info-v1__value">
                                {prepareCost(cost)}
                            </span>
                        </>
                    )
                }
                <button
                    className='cart-list__hint info-tooltip js-cart-delivery'
                    type='button'
                    data-vendor-id={props.card.criticalCatalogData.brandId}
                    data-tooltip-content="#tooltip-delivery"
                    >
                    <IconV1 {...{
                        svgSpriteId: 'info',
                    }} />
                </button>
            </div>
        );
    }

    return (
        <div className="delivery-info-v1">
            {renderDate()}
            {renderCost()}
        </div>
    );

}

export default DeliveryInfoOldProjectV1;